export const TableHeader: React.FC<React.PropsWithChildren<{ ariaLabel: string }>> = ({
  children,
  ariaLabel,
}) => {
  return <th aria-label={ariaLabel}>{children}</th>
}
